/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  GroupAssociation,
  GroupAssociationFromJSON,
  GroupAssociationFromJSONTyped,
  GroupAssociationToJSON,
} from "./GroupAssociation";

/**
 *
 * @export
 * @interface GroupAssociationListResponse
 */
export interface GroupAssociationListResponse {
  /**
   *
   * @type {number}
   * @memberof GroupAssociationListResponse
   */
  offset: number;
  /**
   *
   * @type {number}
   * @memberof GroupAssociationListResponse
   */
  limit: number;
  /**
   *
   * @type {string}
   * @memberof GroupAssociationListResponse
   */
  order: string;
  /**
   *
   * @type {string}
   * @memberof GroupAssociationListResponse
   */
  sort: string;
  /**
   *
   * @type {number}
   * @memberof GroupAssociationListResponse
   */
  count: number;
  /**
   *
   * @type {Array<GroupAssociation>}
   * @memberof GroupAssociationListResponse
   */
  data: Array<GroupAssociation>;
}

export function GroupAssociationListResponseFromJSON(
  json: any
): GroupAssociationListResponse {
  return GroupAssociationListResponseFromJSONTyped(json, false);
}

export function GroupAssociationListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GroupAssociationListResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    offset: json["offset"],
    limit: json["limit"],
    order: json["order"],
    sort: json["sort"],
    count: json["count"],
    data: (json["data"] as Array<any>).map(GroupAssociationFromJSON),
  };
}

export function GroupAssociationListResponseToJSON(
  value?: GroupAssociationListResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    offset: value.offset,
    limit: value.limit,
    order: value.order,
    sort: value.sort,
    count: value.count,
    data: (value.data as Array<any>).map(GroupAssociationToJSON),
  };
}
